// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"atlas-map_wrapper__wNQWS","desktopTileButtons":"atlas-map_desktopTileButtons__Cy5jT","overlay":"atlas-map_overlay___yUDH"};